import { find } from 'es-toolkit/compat';
import React from 'react';

import {
  BulkChangesSummary,
  RowsChangesSummary,
} from 'components/atoms/EditableDataGrid/TableEditingContext/ChangesSummary';
import { AnnotationAssignment } from 'interfaces/annotation';
import { formatFieldValue } from 'interfaces/genericFields/formatFieldValues';
import { AnnotationAssignmentFieldContext, annotationAssignmentFields } from './fields';

export const AnnotationAssignmentBulkChangesSummary: React.FC<
  React.PropsWithChildren<{
    bulkChanges: object;
    fieldsContext: AnnotationAssignmentFieldContext;
  }>
> = ({ bulkChanges, fieldsContext }) => {
  return (
    <BulkChangesSummary
      bulkChanges={bulkChanges}
      fieldToDisplayString={(fieldId) =>
        find(annotationAssignmentFields, (f) => f.dataKey === fieldId)?.label || fieldId
      }
      valueToDisplayString={(value, fieldId) => {
        const field = find(annotationAssignmentFields, (f) => f.dataKey === fieldId);
        if (!field) {
          console.warn(`Could not find field ${fieldId}`);
          return value;
        }
        return formatFieldValue(value, field, fieldsContext);
      }}
    />
  );
};

export const AnnotationAssignmentRowChangesSummary: React.FC<
  React.PropsWithChildren<{
    changes: Partial<AnnotationAssignment>;
    newRowValue?: AnnotationAssignment;
    currentRowValue?: AnnotationAssignment;
    fieldsContext: AnnotationAssignmentFieldContext;
  }>
> = ({ newRowValue, currentRowValue, changes, fieldsContext }) => {
  const name = newRowValue?.name || currentRowValue?.name;
  const annotationAssignmentId =
    newRowValue?.annotationAssignmentId || currentRowValue?.annotationAssignmentId || changes?.annotationAssignmentId;
  return (
    <RowsChangesSummary
      rowsChanges={{ changes }}
      rowToDisplayString={() =>
        `Annotation assignment ${name ? `"${name}" (${annotationAssignmentId})` : annotationAssignmentId}`
      }
      fieldToDisplayString={(fieldId) =>
        find(annotationAssignmentFields, (f) => f.dataKey === fieldId)?.label || fieldId
      }
      valueToDisplayString={(value, fieldId) => {
        const field = find(annotationAssignmentFields, (f) => f.dataKey === fieldId);
        if (!field) {
          console.warn(`Could not find field ${fieldId}`);
          return value;
        }
        return formatFieldValue<any, AnnotationAssignment, AnnotationAssignmentFieldContext>(
          value,
          field,
          fieldsContext
        );
      }}
    />
  );
};
